export default "__VITE_ASSET__BhVpyum$__"